import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from '../components/layout/Sidebar';
import Header from '../components/layout/Header';
import { Container } from 'react-bootstrap';
import BreadCrumbs from '../components/BreadCrumbs/BreadCrumbs';
// import localforage from "localforage";
// import BreadCrumbs from "../components/BreadCrumbs/BreadCrumbs";

function Dashboard() {
    const [sidebarToggle, setsidebarToggle] = useState(false);

    const sidebarHandler = () => {
        setsidebarToggle((wasOpened) => !wasOpened);
    };

    return (
        <>
            <div className="position-relative bg-white d-flex p-0">
                <Sidebar sidebarToggle={sidebarToggle} sidebarHandler={sidebarHandler} />
                <div className={`content ${sidebarToggle && 'show'}`}>
                    <Header sidebarHandler={sidebarHandler} />
                    <Container fluid className="mt-3 inner-content">
                        <BreadCrumbs />
                        <Outlet />
                    </Container>
                </div>
            </div>
        </>
    );
}

export default Dashboard;
